import {Permission} from '../types';
import {usePermissionWithReason} from './usePermissionWithReason';

export const useCheckPermission = (requiredPermission: Permission): boolean => {
  const permission = usePermissionWithReason(requiredPermission);

  return permission.hasPermission;
};
